import React, {Component, PropTypes} from 'react'
import Icon from './Icon'
import style from './DownloadIcon.less'

class DownloadIcon extends Component {
    static propTypes = {
        progress: PropTypes.number
    }

    render() {
        const {progress, ...other} = this.props

        const percentage = (value) => {
            return value && (value * 100) || 0
        }

        return (
            <div className={style.default}>
                {progress > 0 && (
                    <div
                        className={style.progress}
                        style={{minHeight: percentage(progress) + '%'}} />
                )}
                <Icon icon='download' size='sm' />
            </div>
        )
    }
}

export default DownloadIcon


// WEBPACK FOOTER //
// ./lib/core/components/DownloadIcon.js